import {Component} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {DisinfectionprogramService} from '@services/disinfectionprogram.service';
import {LoaderService} from '@services/loader.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-edit-disinfection',
    templateUrl: './edit-disinfection.component.html',
    styleUrl: './edit-disinfection.component.scss'
})
export class EditDisinfectionComponent {
    public disinfectionForm: FormGroup;
    public disinfectionlist: any[] = [];
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    public disinfectionId: number;

    constructor(
        private fb: FormBuilder,
        private toastr: ToastrService,
        private loaderService: LoaderService,
        private disInfectionService: DisinfectionprogramService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.disinfectionId = this.route.snapshot.params['id']; // Capture the ID from the route

        this.disinfectionForm = this.fb.group({
            id: this.disinfectionId,
            disinfectionTypeId: ['', Validators.required],
            disinfectionProgramName: ['', Validators.required],
            instructionsList: this.fb.array([this.createInstruction()]),
            userId: [null], // You can set the userId based on your logic
            date: [new Date().toISOString()]
        });

        this.getDisInfectionTypeList();

        if (this.disinfectionId) {
            this.loadDisinfectionDetails(this.disinfectionId); // Load the disinfection details for editing
        }
    }

    createInstruction(): FormGroup {
        return this.fb.group({
            instructions: ['', Validators.required]
        });
    }

    addInstruction(): void {
        this.instructionsList.push(this.createInstruction());
    }

    removeInstruction(index: number): void {
        this.instructionsList.removeAt(index);
    }

    get instructionsList(): FormArray {
        return this.disinfectionForm.get('instructionsList') as FormArray;
    }

    getDisInfectionTypeList() {
        this.disInfectionService
            .getDisInfectionProgramList()
            .subscribe((result) => {
                this.disinfectionlist = result;
            });
    }
    cancelEdit() {
        this.router.navigate(['/disinfection-list']);
    }
    loadDisinfectionDetails(id: number): void {
        this.disInfectionService
            .getDisInfectionById(id)
            .subscribe((response) => {
                this.disinfectionForm.patchValue({
                    disinfectionProgramName:
                        response.disinfectionProgramName || '',
                    disinfectionTypeId: response.disinfectionTypeId,
                    userId: response.userId,
                    date: response.date
                });

                this.instructionsList.clear(); // Clear the existing instructions

                response.instructionsList.forEach((instruction: any) => {
                    this.instructionsList.push(
                        this.fb.group({
                            instructions: [
                                instruction.instructions,
                                Validators.required
                            ]
                        })
                    );
                });
            });
    }

    onSubmit(): void {
        this.loaderService.showLoader();
        this.isAuthLoading = true;

        if (this.disinfectionForm.valid) {
            const formValue = this.disinfectionForm.value;

            this.disInfectionService.updateDisInfection(formValue).subscribe({
                next: (response) => {
                    this.handleSuccess();
                },
                error: (error) => {
                    this.handleError(error);
                }
            });
        } else {
            this.handleFormErrors();
        }
    }

    handleSuccess(): void {
        setTimeout(() => {
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
            this.toastr.success("Disinfection Program Updated Successfully");
            this.router.navigate(['/disinfection-list']);
        }, 2000);
    }

    handleError(error: any): void {
        setTimeout(() => {
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
            this.toastr.error(error.error);
        }, 2000);
    }

    handleFormErrors(): void {
        this.loaderService.hideLoader();
        this.disinfectionForm.markAllAsTouched();
        this.isAuthLoading = false;
        this.toastr.error('Please fill the required fields');
    }
}
